import axios from "../config";
import { API_VERSION_2 } from "config";

export const getClusters = (params) =>
  axios.get(`${API_VERSION_2}/cluster`, { params });

export const getCluster = (id) =>
  axios.get(`${API_VERSION_2}/cluster/${id}`);